import React,{useState} from 'react'
import {Card} from 'react-bootstrap'
import styles from "../../components/LeftNavigation/DesignerControls/BasicControls.module.css"
import "./CollapseCard.css";
import DownArrow from "../../Icons/DownArrow"
import UpArrow from "../../Icons/CollapsibleArrowUp"
import DeleteIcon from "../../Icons/DeleteIcon"
import { useTranslation } from 'react-i18next'
import { makeStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import UpArrowControlSet from '../../Icons/UpArrowControlSet';

const useStyles = makeStyles({

  tooltip: {
    maxWidth: "260px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    color: "black",
    border: "#70707075 1px solid",
    boxShadow: "0px 3px 6px #00000029",
    opacity: 1,
    fontSize: 12,
  },
  arrow: {
    "&:before": {
      border: "1px solid #70707075",
    },
    color: "white",
    fontSize: 15,
  },
});
function CollapsibleComponent({heading,body,children,state, bodyStyle, handleState, controlled,name, inlineStyle,headerStyling,divStyling,id,isDoclist,docIndex,deleteDocument,createPageTemplate}){
    
    const [showCollapsibleBody, setShowCollapsibleBody] = useState(id=="0"? true :false);
    const classes = useStyles();
	const { t } = useTranslation(['styles', 'translation']);

    function handleClick(){
        if(handleState){
            handleState(name);
        }
        setShowCollapsibleBody(!showCollapsibleBody);
    }

    return (
        <div
        key={heading}
        className={"collapseCard " + "configuration " + divStyling}
        style={{ borderTop: "0px !important" }}
      >
      {heading === "Events" ? (
        <div
          className={headerStyling + " configurationHeader "}
          onClick={() => handleClick()}
        >
          <div className="configurationHeaderDiv">
            <Tooltip
              title={t(`translation:${"Events Tooltip Content"}`)}
              classes={{ tooltip: classes.tooltip, arrow: classes.arrow }}
              placement={"bottom-start"}
              arrow
            >
              <span className="headingSpan">
                {t(`translation:${heading}`)}
              </span>
            </Tooltip>

            
            <div className="arrowsAdjustment">
              {controlled ? (
                state === name ? (
                  <UpArrow color={"#606060"} />
                ) : (
                  <DownArrow color={"#606060"} />
                )
              ) : showCollapsibleBody ? (
                // <UpArrow color={"#606060"} />
                <UpArrowControlSet color={"#606060"}/>
              ) : (
                <DownArrow color={"#606060"} />
              )}
            </div>
          </div>
        </div>
      ) : (
        <div
          className={headerStyling + " configurationHeader "}
          onClick={() => handleClick()}
        >
          <div className={createPageTemplate ? "configurationHeaderDiv1" : "configurationHeaderDiv"}>
            <span className="headingSpan">
              {t(`translation:${heading}`)}
            </span>
            
            <div className="arrowsAdjustment" style={isDoclist ? {display:"flex",alignItems:"center"}:null}>
            {isDoclist && <div onClick={(e)=>deleteDocument(e,docIndex)} style={{paddingRight:"5px"}}><DeleteIcon /></div>
            }
              {controlled ? (
                state === name ? (
                  <UpArrow  color={"#606060"} />
                ) : (
                  <DownArrow  color={"#606060"} />
                )
              ) : showCollapsibleBody ? (
                // <UpArrow  color={"#606060"} />
                 <UpArrowControlSet  color={"#606060"}/>
              ) : (
                <DownArrow  color={"#606060"} />
              )}
            </div>
          </div>
        </div>
      )}

      {controlled
        ? state === name && (
            <div style={bodyStyle} className="cardBodyProperties">
              {body || children}
            </div>
          )
        : showCollapsibleBody && (
            <div style={bodyStyle} className="cardBodyProperties">
              {body || children}
            </div>
          )}
    </div>)
}

export default CollapsibleComponent